// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ReorderPadApiModal } from "@adl/App/Store/Reducers";
import { ApiParameter, HasPagingParameters, post } from "@insite/client-framework/Services/ApiService";

const reorderPadUrl = "/api/custom/ReOrderPad/Items";

export interface ReorderPadApiParameter extends ApiParameter, HasPagingParameters {
    fromDate?: string;
    toDate?: string;
    sortBy?: string;
    metaDescription?: string;
    productErpNumber?: string;
    id: string;
}

export function loadReorderPadApiParameter(parameter: ReorderPadApiParameter) {
    return post<ReorderPadApiParameter, ReorderPadApiModal>(`${reorderPadUrl}`, parameter);
}
